/**
* @Author: Roxy Chen
* @Date:   2016-08-20T15:45:05+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-20T16:59:32+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/


import React, { Component } from "react";
import PropTypes from "prop-types";


export default class AnimateEffect extends Component {
  static propTypes = {
    trigger: PropTypes.bool.isRequired ,
    className:PropTypes.string.isRequired,
    delay: PropTypes.number.isRequired ,
    effect: PropTypes.string.isRequired,
    hidden: PropTypes.bool.isRequired
  };

  static defaultProps = {
    trigger: false ,
    className: "",
    delay: 0,
    effect: "",
    hidden: false
  }

  constructor() {
    super()
    this.state = { effect: "" }
  }

  setEffect (effect) {
    this.setState({ effect })
  }

  render() {
    const {
      trigger , className, children , delay , effect , hidden
    } = this.props;
    
    console.log('AnimateEffect render:', { trigger, effect, delay, className, currentEffect: this.state.effect });
    
    if (trigger && !this.state.effect) {
      setTimeout(()=>this.setEffect(effect) , delay );
    }
    
    var xx = Object.assign({}, this.props); 
    delete xx["trigger"] // silent warning
    delete xx["delay"]   // remove delay from DOM props
    delete xx["effect"]  // remove effect from DOM props
    delete xx["hidden"]  // remove hidden from DOM props
    
    const finalClassName = `${className} animate__animated animate__${this.state.effect}`;
    console.log('Final className:', finalClassName);
    
    return(
      <div {...xx}
        style={ hidden ? {display: "none"} : (this.state.effect ? {opacity: 1} : {opacity: 0.3}) }
        className={finalClassName}>

        { children }

      </div>
    )
  }
}

